import React, { useState, useEffect } from "react";
import { Paper, Box, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HeadingDetail from "../components/HeadingDetail";
import UserTable from "./UserTable";
import AdvancedConfirmDialog from "components/common/AdvancedConfirmDialog";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";

const ConferenceDetail = ({
  conference,
  onBack,
  handleOpenEditAdminDialog,
  form,
  setForm,
  filterUsers,
  handleChangeSearchInput,
  handleChangeUnitDropdown,
  handleChangeDepartmentDropdown,
  handleUpdateAccountRole,
}) => {
  const { t: getLabel } = useTranslation();

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [removeItem, setRemoveItem] = useState(null);
  const [isOpenDialogRemoveAdmin, setIsOpenDialogRemoveAdmin] = useState(false);

  const handleAddSelected = user => {
    setSelectedUsers(prev => {
      const isSelected = prev.some(u => u.accountId === user.accountId);
      if (isSelected) {
        return prev.filter(u => u.accountId !== user.accountId);
      } else {
        return [...prev, user];
      }
    });
  };

  const handleRemoveAdmin = removeItem => {
    if (removeItem) setRemoveItem(removeItem);
    setIsOpenDialogRemoveAdmin(true);
  };

  const getRemainAdminAccountIds = () => {
    const originalAdminIds = conference?.adminAccountIds || [];
    const removedAdmins = removeItem ? [removeItem] : selectedUsers;
    return originalAdminIds.filter(adminId => !removedAdmins.some(u => u.accountId === adminId));
  };

  const onConfirmRemove = () => {
    const remainAccountIds = getRemainAdminAccountIds();
    handleUpdateAccountRole({
      serviceId: conference.serviceId,
      accountIds: remainAccountIds,
    });
    setIsOpenDialogRemoveAdmin(false);
    setSelectedUsers([]);
  };

  useEffect(() => {
    setForm(prev => ({ ...prev, state: 1 }));
  }, [conference]);

  useEffect(() => {
    if (!conference?.adminAccountIds) {
      setSelectedUsers([]);
    }
  }, [filterUsers, conference]);

  return (
    <Paper sx={{ px: 2, py: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <IconButton onClick={onBack}>
            <ArrowBackIcon />
          </IconButton>
          <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>{conference.name}</Typography>
        </Box>
      </Box>
      <HeadingDetail
        form={form}
        onChangeSearchInput={handleChangeSearchInput}
        onOpenEditAdminDialog={() => handleOpenEditAdminDialog(conference)}
        onChangeUnitDropdown={handleChangeUnitDropdown}
        onChangeDepartmentDropdown={handleChangeDepartmentDropdown}
        selectedUsers={selectedUsers}
        onRemoveAdmin={handleRemoveAdmin}
      />
      <UserTable
        title="Danh sách quản trị viên"
        users={filterUsers.filter(user => conference?.adminAccountIds?.includes(user.accountId))}
        selectedUsers={selectedUsers}
        onSelected={handleAddSelected}
        onActionClick={handleRemoveAdmin}
        actionType="remove"
      />
      <AdvancedConfirmDialog
        open={isOpenDialogRemoveAdmin}
        title={getLabel(LangConstant.TXT_CONFIRM_DELETE_ADMIN_TITLE)}
        content={getLabel(LangConstant.TXT_CONFIRM_DELETE_ADMIN_TEXT)}
        submitProps={{
          submitText: getLabel("L_DELETE"),
          onClick: () => onConfirmRemove(),
        }}
        cancelProps={{
          onClick: () => setIsOpenDialogRemoveAdmin(false),
        }}
      />
    </Paper>
  );
};

export default ConferenceDetail;
